import { render, staticRenderFns } from "./SingleTransportService.vue?vue&type=template&id=509cb3fa&scoped=true&"
import script from "./SingleTransportService.vue?vue&type=script&lang=js&"
export * from "./SingleTransportService.vue?vue&type=script&lang=js&"
import style0 from "./SingleTransportService.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleTransportService.vue?vue&type=style&index=1&id=509cb3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509cb3fa",
  null
  
)

export default component.exports